import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import {
  videoCallFrameContentSx,
  videoCallFrameOuterSx,
  videoCallFrameSidebarSx,
  videoCallFrameVideoAreaSx,
  videoCallFrameNamesBarSx,
  videoCallFrameNameSx,
} from "../../videoFrameStyles";

const MAIS_SAUDE_LOGO = `${process.env.PUBLIC_URL || ""}/mais-saude-logo.png`;

interface VideoCallFrameProps {
  doctorName: string;
  patientName: string;
  isDesktop: boolean;
  children: ReactNode;
}

export const VideoCallFrame = ({
  doctorName,
  patientName,
  isDesktop,
  children,
}: VideoCallFrameProps) => {
  return (
    <Box sx={videoCallFrameOuterSx}>
      {isDesktop ? (
        <Box sx={videoCallFrameSidebarSx(isDesktop)}>
          <Box
            component="img"
            src={MAIS_SAUDE_LOGO}
            alt="Mais Que Saúde"
            sx={{
              width: "100%",
              maxWidth: 88,
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Box>
      ) : null}

      <Box sx={videoCallFrameContentSx(isDesktop)}>
        <Box sx={videoCallFrameNamesBarSx}>
          <Typography sx={videoCallFrameNameSx} title={doctorName}>
            Médico: {doctorName}
          </Typography>
          <Typography
            sx={{ ...videoCallFrameNameSx, textAlign: "right" }}
            title={patientName}
          >
            Paciente: {patientName}
          </Typography>
        </Box>

        <Box sx={videoCallFrameVideoAreaSx}>{children}</Box>
      </Box>
    </Box>
  );
};

export default VideoCallFrame;
